export const ENTITY_PROFILE_CONSTANTS = {
  SIDEBAR_ID: 'sidebar-info',
  DEFAULT_Z_INDEX: 10,
  NAVIGATION_PATHS: {
    CONTACTS: '/addressBook/contacts',
  },
  ANALYTICS_EVENTS: {
    PROFILE_VIEW: 'profileView',
  },
} as const;